<template>
  <div id="product-faq-content-wrapper">
    <v-expansion-panels>
      <v-expansion-panel class="my-1 light-grey" v-for="(faq,i) in productFaqs" :key="i">
        <v-expansion-panel-header>{{ faq.question }}</v-expansion-panel-header>
        <v-expansion-panel-content class="font-size-14">{{ faq.answer }}</v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import staticFAQ from "../../mock/staticFAQ";
export default {
  props: {
    subject: String
  },
  data() {
    return {
      showAnswer: false
    };
  },
  methods: {
    taggleAnswerDialog() {
      this.showAnswer = !this.showAnswer;
    }
  },
  computed: {
    productFaqs() {
      return staticFAQ[this.subject];
    }
  }
};
</script>

<style scoped>
#product-faq-content-wrapper {
  margin-top: 75px;
}

.v-expansion-panel-header {
  border: 1px solid #333333;
}

.v-expansion-panel-content {
  background-color: #f6f6f7;
}
.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel:not(:first-child)::after {
  border-color: transparent !important;
}
</style>>

